export default {
  access_token: '',
  curr_user: {},
  course_list: [], // AK: used for showing autocomplete results
  selectedCourseObjFromFilter: {}, // AK: used to store previously selected course object from Filter
  selectedMasterClassModuleList: [], // AK: used for holding selected master class lesson list temporary(While filering)
  groupList: [], // AK: used to store all group list (without filter)
  challengeList: [], // AK: used to store Challenge List
  isOverlayVisible: false, // AK: used for avoiding background scrolling when any type of overlay is shown to user
  topicList: [], // AK: used to store Topic List
  participantListForCurrentSelectedGroup: [], // AK: Used only for keeping participant list for selected Group (Usage: Search Participant results using group)
  techniqueList: [], // AK: Used to store all techniques
  groupCourseList: [], // AK: used to store all group courses
  cohortList: [], // AK: used to store all cohort list (without filter)
  leapsChallengesList: [], // AK: used to store all LEAPS Goal list (without filter)
  leapsMeditationList: [], // AK: used to store all LEAPS Meditation list (without filter)
  leapsActionList: [], // AK: used to store all LEAPS Action list (without filter),
  leapsCategoryList: [], // AK: used to store all LEAPS Category list (without filter),
  leapsEnergyList: [], // AK: used to store all LEAPS Energy list (without filter),
  leapsAffirmationList: [], // AK: used to store all LEAPS Affirmation list (without filter),
  leapsIntentionList: [], // AK: used to store all LEAPS Intention list (without filter),
  msNotificationTemplateList: [], // AK: used to store all MS Notification Template list (without filter),
  availableLeapsChallengesForCohortList: [], // AK: used to store all Available LEAPS Goal list for Cohort (without filter)
  availableLeapsActionsForCohortList: [], // AK: used to store all Available LEAPS Actions list for Cohort (without filter)
  availableLeapsMeditationForGroupList: [], // AK: used to store all Available LEAPS Meditation list for Group (without filter)
  availableLeapsIntentionForGroupList: [], // AK: used to store all Available LEAPS Intention list for Group (without filter)
  userList: [], // AK: used to store all User list (without filter)
  allowToolkitForAll: false, // AK: Used to keep track the button state (Un-enrolled-partcipant)
  isLessonSwipped: false, // AK: Used to keep track for Lesson Swipping operation
  createMcqOptions: [], // AK: Used while creating/Updating MCQ element
  fileRepositoryList: [], // AK: Used to store all File Repository list (without Filter)
  isComingFromLogin: false, // AK: Used to show dashboard when user login first time
  mcqReportSelectedGCMObj: {}, // AK: used to store selected Group Course Master Obj of MCQ Report Page
  adminUsers: [], // used to store all admin users list
  senderEmailList: [], // AK: Used to hold all email id's used to send emails
  templateList: [], // AK: Used to hold all Non-Progression Template list
  progressionTemplateList: [], // AK: Used to hold all Progression Template list
  emailDashboardTemplateList: [], // AK: Used to hold all email Dashboard Template list
  scheduledDashboardEmailList: [], // AK: Used to hold all scheduled Dashboard Email list
  passwordRecoveryKey: '',
  currentCourseObj: {}, // AK: used to hold the course object which created using CSV only
  hightLightOptionExplictly: false, // AK: used when user redirected from manage course screen to course explictly
  isChallengeCreated: false, // AK: Used to reset topic filter when user create new challenge
  selectedGroupCourseObj: {}, // AK: Used to keep showing selected GroupCourse name in all Sub-Filters of Report
  selectedCohortObj: {}, // AK: Used to keep showing selected Cohort name in all  Sub-Filters of Report
  ssoClientList: [], // AK: Used to hold the all SSO Client list
  gccData: {}, // AK: Used to hold all GCC data (New dashboard) for selected User/Group Admin
  createProgressBuckets: [],  // HB: Used to hold progressBuckets, while creating Groups
  motdList: [], // AK: to store all MOTD list
  totalUsers: 0, // AK: Used to keep track of number of total users
  milestoneInfoList: [], // AK: Used to hold the default Milestone Info list
  elementIdsToComplete: [], // AK: Used to hold element id's (Milestone type - Specific Element Completion)
  disallowCourseForAll: false, // AK: Used to keep track the button state (Un-enrolled-partcipant)
  masterTopicList: [], // AK: Used to hold master topic list
  mentoraMomentCourseList: [], // AK: Used to hold all mentora moment courses
  allowCertificateForAll: false, // AK: Used to keep track the button state (Un-enrolled-partcipant)
  currDashboardTabSelection: 1, // AK: Used to keep track of which tab is currently selected on Dashboard
  learningLevelList: [], // AK: Used to hold learning level list
  assessmentList: [], // AK: Used to assessment list.
  recAssessmentList: [], // AK: Used to hold Recommendation list.
  selectedAssessmentElementList: [], // AK: used for holding selected Assessment element list temporary(While filering)
  selectedAssessmentObjFromFilter: {}, // AK: used to store previously selected Assessment object from Filter
  assessmentElementListToPost: [], // AK: Used to hold the selected steps for the update assessment
  personalizationElementListToPost: [], // AK: Used to hold the selected steps for the Personalization Add/Remove element action
  expandAllLessons: '{flagToCheck}_{randomQuidId}', // AK: Used to hold expand all lesson state
  actionList: [], // AK: Used to hold the associated action list for rule (Element level personalization)
  selectedCohortIds: [], // AK: Used to hold the selected cohort Id's of new report.
  /** Added for the Client Dashboard */
  baseUrl: '',
  minDate: '',
  maxDate: 'today',
  groups: [], // Only the Groups allowed for the authenticated user. "All" in case of an admin and just a single Group in case of a GroupAdmin
  groupCourses: [], // GroupCourses for the selected Group
  groupCoursesCohorts: [], // GroupCourseCohorts for the Selected GroupCourses
  selectedGroup: {}, // The Group currently selected in the GroupCourseCohort filter. Defaults to first Group.
  selectedGroupCourses: [],
  selectedCohorts: [], // The Cohorts currently selected in the GroupCourseCohort Filter
  stats: [], // Participant stats / records for the selected Group
  progressBuckets: [], // Progress Buckets
  isLoading: false, // Used to show / hide the loading animation
  isUserProfileLoaded: false, // Used for showing the internal webpage only if the user profile has been fetched from server and account type if GroupAdmin or Admin,
  allGroupData: {},
  requestError: {},
  screenLoadingList: [], // used to hold screen loading asset list
  defaultProgBuckets: [
    {
      name: '0%',
      label: '0%',
      min: 0,
      max: 0
    },
    {
      name: '1% - 40%',
      label: '1% - 40%',
      min: 1,
      max: 40
    },
    {
      name: '41% - 79%',
      label: '41% - 79%',
      min: 41,
      max: 79
    },
    {
      name: '80% - 99%',
      label: '80% - 99%',
      min: 80,
      max: 99
    },
    {
      name: 'At 100%',
      label: 'At 100%',
      min: 100,
      max: 100
    }
  ],

  selectedCourseIds: []
}



// WEBPACK FOOTER //
// ./src/store/state.js